/* eslint-disable no-bitwise */

// This file generates a globally unique per every single page load. It helps
// backend identify all requests made by a particular browser page load. Since
// Sail Data is workspaced, applications forcefully have only one copy of this
// file and thus the id is also unique.

export default 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
  const r = Math.floor(Math.random() * 16);
  const v = c === 'x' ? r : (r & 0x3) | 0x8;

  return v.toString(16);
});
